import type { BaseCategoryRepository } from "#/Data/_Bases/BaseCategoryRepository.ts";
import type { BaseApplicationRepository } from "./BaseApplicationRepository";
import type { BaseBarcodeTemplateRepository } from "./BaseBarcodeTemplateRepository";
import type { BaseClassificationRepository } from "./BaseClassificationRepository";
import type { BaseCustomerDisplayRepository } from "./BaseCustomerDisplayRepository";
import type { BaseCustomerGroupRepository } from "./BaseCustomerGroupRepository";
import type { BaseCustomerRepository } from "./BaseCustomerRepository";
import type { BaseEnterpriseRepository } from "./BaseEnterpriseRepository";
import type { BaseGiftCardRepository } from "./BaseGiftCardRepository";
import type { BaseKitchenOrderRepository } from "./BaseKitchenOrderRepository";
import type { BaseKitchenScreenRepository } from "./BaseKitchenScreenRepository";
import type { BaseLockedResourceRepository } from "./BaseLockedResourceRepository";
import type { BaseLoyaltyRepository } from "./BaseLoyaltyRepository";
import type { BaseMovementRepository } from "./BaseMovementRepository";
import type { BaseOutletRepository } from "./BaseOutletRepository";
import type { BasePageRuleRepository } from "./BasePageRuleRepository";
import type { BasePaymentMethodRepository } from "./BasePaymentMethodRepository";
import type { BasePriceListRepository } from "./BasePriceListRepository";
import type { BasePriceSetRepository } from "./BasePriceSetRepository";
import type { BaseProductRepository } from "./BaseProductRepository";
import type { BasePromotionCategoryRepository } from "./BasePromotionCategoryRepository";
import type { BasePromotionRepository } from "./BasePromotionRepository";
import type { BaseReceiptRepository } from "./BaseReceiptRepository";
import type { BaseRegisterRepository } from "./BaseRegisterRepository";
import type { BaseSalesKeyRepository } from "./BaseSalesKeyRepository";
import type { BaseSalesRepository } from "./BaseSalesRepository";
import type { BaseStocktakeAccumulatedRepository } from "./BaseStocktakeAccumulatedRepository";
import type { BaseStocktakeRepository } from "./BaseStocktakeRepository";
import type { BaseStocktakeScannedRepository } from "./BaseStocktakeScannedRepository";
import type { BaseSupplierRepository } from "./BaseSupplierRepository";
import type { BaseSystemRepository } from "./BaseSystemRepository";
import type { BaseTakingsRepository } from "./BaseTakingsRepository";
import type { BaseTaxRateRepository } from "./BaseTaxRateRepository";
import type { BaseTransfereeRepository } from "./BaseTransfereeRepository";
import type { BaseUploadRepository } from "./BaseUploadRepository";
import type { BaseUserRepository } from "./BaseUserRepository";
import type { BaseVendorConnectionRepository } from "./BaseVendorConnectionRepository";
import type { DataSourceTables } from "./DataSourceTables";

export default abstract class BaseDataSource implements DataSourceTables {
    // Tables
    public products!: BaseProductRepository;
    public customers!: BaseCustomerRepository;
    public customerGroups!: BaseCustomerGroupRepository;
    public promotions!: BasePromotionRepository;
    public promotionCategories!: BasePromotionCategoryRepository;
    public users!: BaseUserRepository;
    public priceLists!: BasePriceListRepository;
    public paymentMethods!: BasePaymentMethodRepository;
    public salesKeys!: BaseSalesKeyRepository;
    public receipts!: BaseReceiptRepository;
    public giftCards!: BaseGiftCardRepository;
    public loyalty!: BaseLoyaltyRepository;
    public customerDisplays!: BaseCustomerDisplayRepository;
    public sales!: BaseSalesRepository;
    public brands!: BaseClassificationRepository;
    public categories!: BaseCategoryRepository;
    public families!: BaseClassificationRepository;
    public tags!: BaseClassificationRepository;
    public outlets!: BaseOutletRepository;
    public registers!: BaseRegisterRepository;
    public uploads!: BaseUploadRepository;
    public taxRates!: BaseTaxRateRepository;
    public takings!: BaseTakingsRepository;
    public pageRules!: BasePageRuleRepository;
    public suppliers!: BaseSupplierRepository;
    public priceSets!: BasePriceSetRepository;
    public transferees!: BaseTransfereeRepository;
    public movements!: BaseMovementRepository;
    public stocktakes!: BaseStocktakeRepository;
    public stocktakeScanned!: BaseStocktakeScannedRepository;
    public stocktakeAccumulated!: BaseStocktakeAccumulatedRepository;
    public applications!: BaseApplicationRepository;
    public barcodeTemplates!: BaseBarcodeTemplateRepository;
    public vendorConnections!: BaseVendorConnectionRepository;
    public lockedResources!: BaseLockedResourceRepository;
    public system!: BaseSystemRepository;
    public enterprises!: BaseEnterpriseRepository;
    public kitchenOrders!: BaseKitchenOrderRepository;
    public kitchenScreens!: BaseKitchenScreenRepository;

    // Methods
    public abstract transaction(table: Array<keyof DataSourceTables>, callback: () => Promise<void>): Promise<void>;
    public abstract clearDatabase(): Promise<void>;
    public abstract getVersion(): Promise<number | undefined>;
}
